import React from 'react';

export default function ContactSection() {
  return (
    <section className="py-20 text-center">
      <div className="relative inline-block mb-8">
        <h2 className="text-4xl md:text-5xl font-black mb-4">
          <span className="bg-gradient-to-r from-purple-400 to-cyan-400 text-transparent bg-clip-text">Давайте работать вместе</span>
        </h2>
        <div className="absolute -inset-4 bg-gradient-to-r from-purple-600 to-cyan-600 blur-3xl opacity-20 -z-10" />
      </div>
      <p className="text-xl text-gray-400 mb-12 max-w-2xl mx-auto">Открыт для новых проектов, коллабораций и интересных предложений</p>
      <a
        href="mailto:mail_me@vikquick.ru"
        className="group relative inline-block px-12 py-6 bg-gradient-to-r from-purple-600 to-cyan-600 rounded-full font-bold text-xl overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/50"
      >
        <span className="relative z-10">Написать письмо</span>
        <div className="absolute inset-0 bg-gradient-to-r from-cyan-600 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </a>
    </section>
  );
}
